import { DonationFrequency } from '@web/graphql-components'
import { useDonationFormContext } from '../../DonationFormProvider'
import { useEffect } from 'react'
import { Box, VStack } from '@web/components/atoms/Layout'
import PageCheckBox from '../atoms/PageCheckBox'
import GivingFrequencySelector from './GivingFrequencySelector'
import { Body2 } from '@web/components/atoms/Typography'
import { roundToTwoDecimals, toDisplayAmountNoDecimal } from '@web/components/utils/format'
import { usePayByInstallment } from '../../donationUtils'

const PayByInstallments = () => {
  const amount = useDonationFormContext((state) => state.formValues.amount) ?? 0
  const settings = useDonationFormContext((state) => state.settings)
  const givingFrequency = useDonationFormContext((state) => state.formValues.givingFrequency)
  const setFormValues = useDonationFormContext((state) => state.actions.setFormValues)
  const isPayByInstallments = useDonationFormContext((state) => state.formValues.isPayByInstallments)
  const { minInstallmentAmount, frequencies, noOfInstallments } = usePayByInstallment()

  useEffect(() => {
    if (amount && amount < minInstallmentAmount && isPayByInstallments) {
      setFormValues({ isPayByInstallments: false })

      return
    }

    if (!isPayByInstallments) {
      if (givingFrequency && !settings?.donationFrequency.includes(givingFrequency)) {
        setFormValues({ givingFrequency: DonationFrequency.OneTime })
      }
      return
    }

    setFormValues({ givingFrequency: DonationFrequency.Monthly })
  }, [amount, isPayByInstallments])

  return amount >= minInstallmentAmount ? (
    <>
      <Box w="100%">
        <PageCheckBox
          id="pay-by-installments"
          label="Pay by instalments"
          isChecked={isPayByInstallments ?? false}
          onChange={() => setFormValues({ isPayByInstallments: !isPayByInstallments })}
        />
      </Box>
      {isPayByInstallments && frequencies && (
        <VStack w="100%">
          <Body2>I want to pay:</Body2>
          <GivingFrequencySelector frequencies={frequencies} defaultFrequency={0} />
          <Body2>
            Thank you for your donation of ${toDisplayAmountNoDecimal(amount)} being $
            {toDisplayAmountNoDecimal(roundToTwoDecimals(amount / noOfInstallments![0]))} per{' '}
            {noOfInstallments![1].replace('s', '')} for {noOfInstallments![0]} {noOfInstallments![1]}.
          </Body2>
        </VStack>
      )}
    </>
  ) : null
}

export default PayByInstallments
